module.exports = __webpack_public_path__ + "static/media/nina.d06cfe86.png";